import Layout from '@/layout';
var marketingRouter = {
  path: '/marketing',
  component: Layout,
  redirect: '/coupon/list',
  name: 'Marketing',
  meta: {
    title: '营销',
    icon: 'clipboard'
  },
  children: [{
    path: 'coupon',
    component: function component() {
      return import('@/views/marketing/coupon/index');
    },
    name: 'Coupon',
    meta: {
      title: '优惠券管理',
      icon: ''
    },
    children: [{
      path: 'list',
      name: 'List',
      meta: {
        title: '优惠券列表',
        icon: '',
        cacheDisposable: true
      },
      component: function component() {
        return import('@/views/marketing/coupon/list/index');
      }
    }, {
      path: 'record',
      name: 'Record',
      meta: {
        title: '领取记录',
        icon: '',
        cacheDisposable: true
      },
      component: function component() {
        return import('@/views/marketing/coupon/record/index');
      }
    }, {
      path: 'sendRecord',
      name: 'sendRecord',
      meta: {
        title: '发送记录',
        icon: '',
        cacheDisposable: true
      },
      component: function component() {
        return import('@/views/marketing/coupon/sendRecord/index');
      }
    }, {
      path: 'immediate',
      name: 'immediate',
      meta: {
        title: '立减活动',
        icon: ''
      },
      component: function component() {
        return import('@/views/marketing/immediate/index');
      }
    }, {
      path: 'package',
      name: 'CouponPackage',
      meta: {
        title: '券包管理',
        icon: ''
      },
      component: function component() {
        return import('@/views/marketing/coupon/package/index');
      }
    }, {
      path: 'package/save/:type',
      name: 'CouponPackageSave',
      meta: {
        title: '券包添加/编辑',
        noCache: true,
        activeMenu: "/marketing/coupon/package"
      },
      hidden: true,
      component: function component() {
        return import('@/views/marketing/coupon/package/save/index');
      }
    }, {
      path: 'list/save/:type:id?',
      name: 'couponAddorEdit',
      meta: {
        title: '优惠券添加',
        noCache: true,
        activeMenu: "/marketing/coupon/list"
      },
      hidden: true,
      component: function component() {
        return import('@/views/marketing/coupon/list/modules/CouponAddorEdit');
      }
    }, {
      path: 'detail/:id',
      name: 'Detail',
      meta: {
        title: '优惠券查看',
        activeMenu: "/marketing/coupon/list"
      },
      component: function component() {
        return import('@/views/marketing/coupon/list/modules/Detail');
      }
    }, {
      path: 'effectAnalysis/:id',
      name: 'EffectAnalysis',
      meta: {
        title: '优惠券效果分析',
        activeMenu: "/marketing/coupon/list"
      },
      component: function component() {
        return import('@/views/marketing/coupon/list/modules/EffectAnalysis');
      }
    }]
  }, {
    path: 'salesPromotion',
    component: function component() {
      return import('@/views/marketing/salesPromotion/index');
    },
    name: 'SalesPromotion',
    meta: {
      title: '促销活动管理',
      icon: ''
    },
    children: [{
      path: 'list',
      name: 'List',
      meta: {
        title: '促销活动列表',
        icon: '',
        cacheDisposable: true
      },
      component: function component() {
        return import('@/views/marketing/salesPromotion/list/index');
      }
    }, {
      path: 'list/save/:type:id?',
      name: 'activityAddorEdit',
      meta: {
        title: '促销活动添加',
        noCache: true,
        activeMenu: "/marketing/salesPromotion/list"
      },
      hidden: true,
      component: function component() {
        return import('@/views/marketing/salesPromotion/list/modules/ActivityAddorEdit');
      }
    }, {
      path: 'detail/:id',
      name: 'Detail',
      meta: {
        title: '促销活动查看',
        activeMenu: "/marketing/salesPromotion/list"
      },
      component: function component() {
        return import('@/views/marketing/salesPromotion/list/modules/Detail');
      }
    }, {
      path: 'effectAnalysis/:id',
      name: 'EffectAnalysis',
      meta: {
        title: '促销活动分析',
        activeMenu: "/marketing/salesPromotion/list"
      },
      component: function component() {
        return import('@/views/marketing/salesPromotion/list/modules/EffectAnalysis');
      }
    }]
  }, {
    path: 'bargain',
    component: function component() {
      return import('@/views/marketing/bargain/index');
    },
    name: 'Bargain',
    meta: {
      title: '砍价管理',
      icon: ''
    },
    alwaysShow: true,
    hidden: true,
    children: [{
      path: 'bargainGoods',
      component: function component() {
        return import('@/views/marketing/bargain/bargainGoods/index');
      },
      name: 'bargainGoods',
      meta: {
        title: '砍价商品',
        icon: ''
      }
    }, {
      path: 'creatBargain/:id?',
      component: function component() {
        return import('@/views/marketing/bargain/bargainGoods/creatBargain');
      },
      name: 'creatBargain',
      meta: {
        title: '砍价商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/bargain/bargainGoods"
      }
    }, {
      path: 'bargainList',
      component: function component() {
        return import('@/views/marketing/bargain/bargainList/index');
      },
      name: 'bargainList',
      meta: {
        title: '砍价列表',
        icon: '',
        cacheDisposable: true
      }
    }]
  }, {
    path: 'groupBuy',
    component: function component() {
      return import('@/views/marketing/groupBuy/index');
    },
    name: 'groupBuy',
    meta: {
      title: '拼团管理',
      icon: ''
    },
    hidden: true,
    children: [{
      path: 'groupGoods',
      component: function component() {
        return import('@/views/marketing/groupBuy/groupGoods/index');
      },
      name: 'groupGoods',
      meta: {
        title: '拼团商品',
        icon: ''
      }
    }, {
      path: 'creatGroup/:id?/:type?',
      component: function component() {
        return import('@/views/marketing/groupBuy/groupGoods/creatGroup');
      },
      name: 'creatGroup',
      meta: {
        title: '拼团商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/groupBuy/groupGoods"
      }
    }, {
      path: 'groupList',
      component: function component() {
        return import('@/views/marketing/groupBuy/groupList/index');
      },
      name: 'groupList',
      meta: {
        title: '拼团列表',
        icon: '',
        cacheDisposable: true
      }
    }]
  }, {
    path: 'seckill',
    component: function component() {
      return import('@/views/marketing/seckill/index');
    },
    name: 'Seckill',
    meta: {
      title: '秒杀管理',
      icon: ''
    },
    children: [{
      path: 'config',
      component: function component() {
        return import('@/views/marketing/seckill/seckillConfig/index');
      },
      name: 'SeckillConfig',
      meta: {
        title: '秒杀配置',
        icon: ''
      }
    }, {
      path: 'list/:timeId?',
      component: function component() {
        return import('@/views/marketing/seckill/seckillList/index');
      },
      name: 'SeckillList',
      meta: {
        title: '秒杀商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/seckill/list"
      }
    }, {
      path: 'creatSeckill/:name?/:timeId?/:id?',
      component: function component() {
        return import('@/views/marketing/seckill/seckillList/creatSeckill');
      },
      name: 'CreatSeckill',
      meta: {
        title: '添加秒杀商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/seckill/list"
      }
    }]
  }, {
    path: 'videoChannel',
    component: function component() {
      return import('@/views/marketing/integral/index');
    },
    name: 'videoChannel',
    meta: {
      title: '视频号管理',
      icon: ''
    },
    children: [{
      path: 'list',
      component: function component() {
        return import('@/views/marketing/videoChannel/videoList/index');
      },
      name: 'VideoChannelList',
      meta: {
        title: '商品列表',
        icon: '',
        noCache: true
      }
    }, {
      path: 'creatVideoChannel/:id?',
      component: function component() {
        return import('@/views/marketing/videoChannel/draftList/creatVideoChannel');
      },
      name: 'CreatVideoChannel',
      meta: {
        title: '添加视频号商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/videoChannel/draftList"
      }
    }, {
      path: 'draftList',
      component: function component() {
        return import('@/views/marketing/videoChannel/draftList/index');
      },
      name: 'draftList',
      meta: {
        title: '草稿列表',
        icon: '',
        noCache: true
      }
    }]
  }, {
    path: 'pageJump',
    component: function component() {
      return import('@/views/marketing/pageJump/index');
    },
    name: 'pageJump',
    meta: {
      title: '小程序分享管理',
      icon: ''
    }
  }, {
    path: 'searchTerm',
    component: function component() {
      return import('@/views/marketing/searchTerm/index');
    },
    name: 'SearchTerm',
    meta: {
      title: '热搜词管理',
      icon: ''
    }
  }, {
    path: 'cartRecommend',
    component: function component() {
      return import('@/views/marketing/cartRecommend/index');
    },
    name: 'cartRecommend',
    meta: {
      title: '推荐策略管理',
      icon: ''
    }
  }, {
    path: 'luckyWheel',
    component: function component() {
      return import('@/views/marketing/luckyWheel/index');
    },
    name: 'LuckyWheel',
    redirect: '/marketing/luckyWheel/list',
    meta: {
      title: '幸运大转盘',
      icon: ''
    },
    children: [{
      path: 'list',
      name: 'LuckyWheelList',
      component: function component() {
        return import('@/views/marketing/luckyWheel/list/index');
      },
      meta: {
        title: '活动管理',
        icon: ''
      }
    }, {
      path: 'setting',
      name: 'LuckyWheelSetting',
      component: function component() {
        return import('@/views/marketing/luckyWheel/setting/index.vue');
      },
      meta: {
        title: '装修与配置',
        icon: ''
      }
    }, {
      path: 'record',
      name: 'LuckyWheelRecord',
      component: function component() {
        return import('@/views/marketing/luckyWheel/record/index.vue');
      },
      meta: {
        title: '抽奖记录',
        icon: ''
      }
    }, {
      path: 'list/save/:mode/:id?',
      name: 'LuckyWheelOperate',
      hidden: true,
      component: function component() {
        return import('@/views/marketing/luckyWheel/operate');
      },
      meta: {
        title: '活动配置',
        noCache: true,
        activeMenu: '/marketing/luckyWheel/list'
      }
    }]
  }]
};
export default marketingRouter;